export function extractArenaGameId(value: string | null): string | null {
  const primary = value?.split('--')[0];
  return primary?.startsWith('arena_') && primary.length > 6 ? primary.slice(6) : null;
}
export function gameShareLink(game: 'rush-mid' | 'arena', id: string, runtime: 'web' | 'tma', origin: string, bot: string, app: string): string {
  if (runtime === 'web') return game === 'arena' ? `${origin}/games/arena/game/${encodeURIComponent(id)}` : `${origin}/games/rush-mid?game=${id}`;
  return `https://t.me/${bot}/${app}?startapp=${game === 'arena' ? 'arena' : 'game'}_${id}`;
}

export function arenaResultLink(runtime: 'web' | 'tma', origin: string, bot: string, app: string): string {
  return runtime === 'web' ? `${origin}/games/arena` : `https://t.me/${bot}/${app}?startapp=arena`;
}
